import ApiCalls from "GlobalUtils/ApiCalls";

export const getHomePageData = ({ pageId, platformId }) => {
  return ApiCalls.fetchApi({
    url: "/api/homepagedata/",
    options: {
      pageId,
      platformId,
    },
  });
};
